import { AuthConfig } from './../model/auth-config.modals';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AccessControlService {

  constructor(private httpClient: HttpClient) {

  }
  static permissionModel: any = [];

  getRoute = new Subject<Boolean>();
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };
  // getAction = new Subject<String>();
  serverUrl: String = environment.serverUrl;
  // call to open menu when user have token if not then it returns
  permissions() {
    return AccessControlService.permissionModel = JSON.parse(localStorage.getItem('permissions'));

  }
  addsystemModule(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.post(this.serverUrl + 'access-control/addmodule', model, httpOptions);
  }

  listallsystemModeules() {
    return this.httpClient.get(this.serverUrl + 'access-control/listallmodules');
  }
  getsystemModulebyId(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/modulebyid/' + id, httpOptions);
  }

  getSectionById(id: any, app_id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/sectionbyid/' + id + '/' + app_id, httpOptions);
  }
  getSectionByModulebyId(id: any, appId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/sectionby-moduleid/' + id + '/' + appId, httpOptions);
  }
  getSectionListByModulebyIdDDL(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/sectionby-moduleid-ddl/' + id, httpOptions);
  }
  getModuleNameAndAppNameById(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/modulename-appnameby-moduleid/' + id, httpOptions);
  }

  addSection(id: any, section: any, appid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/add-section/' + id + '/' + appid, section, httpOptions);
  }

  updateSection(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/update-section/' + model._id, model, httpOptions);
  }

  getActionBySectionId(id: any, app_id: any, moduleId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/actionbyid/' + id + '/' + app_id + '/' + moduleId, httpOptions);
  }
  addSectionAction(id: any, sec_id: any, section_action: any, app_id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/add-section-action/' + id + '/' + sec_id + '/' + app_id, section_action, httpOptions);
  }

  updateSectionAction(sectionId: any, model: any, appid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.post(this.serverUrl + 'access-control/update-section-action/' + sectionId + '/' + appid, model, httpOptions);
  }
  addActionTag(id: any, action_id: any, section_action_tags: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/add-action-tag/' + id + '/' + action_id, section_action_tags, httpOptions);
  }
  updatesystemModule(model: any, appId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/updatemodule/' + model._id + '/' + appId, model, httpOptions);
  }
  deletesystemModule(id: any, appid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.delete(this.serverUrl + 'access-control/deletemodule/' + id + '/' + appid, httpOptions);
  }
  // List alll modules for assigning permission
  listallsystemModeules_Permissions() {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/listallmodules-permission');
  }
  getModulebyApplication_Id(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    const result = this.httpClient.get(this.serverUrl + 'access-control/moduleby-appid/' + id, httpOptions);
    console.log(result);
    return result;
  }

  listallsystemModeulesby_appid_Permissions(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/listallmodules-byappid-permission/' + id, httpOptions);
  }
  // application Screen Fxns
  addApplication(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.post(this.serverUrl + 'access-control/add-application', model, httpOptions);
  }

  getClientapplicationbyId(id: any, clientId?: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + `access-control/client-application-byid/${id}/${clientId}`, httpOptions);
  }

  getapplicationbyIdWithAssignedUsers(id: any, pageNumber: any, clientId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/application-byid-assigned-user/' + id + '/' + pageNumber + '/' + clientId, httpOptions);
  }
  updateApplication(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/update-application/' + model._id, model, httpOptions);
  }
  deleteApplication(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.delete(this.serverUrl + 'access-control/delete-application/' + id, httpOptions);
  }
  listallapplications() {
    return this.httpClient.get(this.serverUrl + 'access-control/listall-applications');
  }

  allapplications_userDashboard() {
    return this.httpClient.get(this.serverUrl + 'access-control/all-application-user-dashboard');
  }
  userApplications(userId: any, clientId: any) {
    return this.httpClient.get(this.serverUrl + 'access-control/user-application/' + userId + '/' + clientId);
  }

  searchUserLoginReport(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.post(this.serverUrl + 'access-control/search-userlogin-report', model, httpOptions);
  }
  getinheritedSectionName(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/inherited-from-name/' + id, httpOptions);
  }
  assignRole(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    const fd = new FormData();
    Object.entries(model).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        fd.append(key, JSON.stringify(value));
      }
      else {
        fd.append(key, <any>value);
      }
    });
    fd.append('updatedBy', localStorage.getItem('user_id'));
    return this.httpClient.post(this.serverUrl + 'access-control/assign-role/', fd);
  }
  removeRole(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    const fd = new FormData();
    Object.entries(model).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        fd.append(key, JSON.stringify(value));
      }
      else {
        fd.append(key, <any>value);
      }
    });
    fd.append('updatedBy', localStorage.getItem('user_id'));
    return this.httpClient.post(this.serverUrl + 'access-control/delete-role/', fd);
  }
  assignUser(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/assign-user/', model, httpOptions);
  }
  updateUserlist(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/update-userlist/', model, httpOptions);
  }
  assignApplicationsToUser(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.put(this.serverUrl + 'access-control/assign-applications/', model, httpOptions);
  }
  unassignRoleFromUser(applicationId: any, userId: any, roleId: any) {
    return this.httpClient.post(this.serverUrl + 'access-control/unassignRole/', { ApplicationId: applicationId, UserId: userId, RoleId: roleId }, this.httpOptions);
  }


  removeApplicationFromUser(applicationId, userId, clientId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.delete(this.serverUrl + `access-control/unassgin-user-from-application/${applicationId}/${userId}/${clientId}`, httpOptions);
  }
  savePreferences(preferences: any) {
    return this.httpClient.post(this.serverUrl + 'access-control/user-preferences', preferences, this.httpOptions);

  }
  getNextDisplayNumber(data: { appId: any; moduleId: any; sectionId: string; type: string; }) {
    return this.httpClient.post(this.serverUrl + 'auth/display-number', data, this.httpOptions);
  }
  isAnyAdmin(app_id: any, clientId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/is-admin/' + app_id + '/' + clientId, httpOptions);
  }
  getOrganizationApplications(id: any) {
    return this.httpClient.get(this.serverUrl + 'access-control/listallapplications-within-org/' + id, this.httpOptions);

  }
  getUserLoginHistory(id: any) {
    return this.httpClient.get(this.serverUrl + 'access-control/history/' + id);
  }
  getApplicationModule(appId: any, roleId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/app-modules/' + appId + '/' + roleId, httpOptions);
  }
  getOrganizationApps(orgId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/applications/' + orgId, httpOptions);
  }
  saveClient(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.post(this.serverUrl + 'access-control/add-client', model, httpOptions);
  }
  getOrganizationClients(orgId: any, pageNumber = 1, pageSize = 0, sortField = null, sortType = null, searchText = '') {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
      params: new HttpParams()
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
        .set('sortField', sortField)
        .set('sortType', sortType)
        .set('searchText', searchText)
    };
    return this.httpClient.get(this.serverUrl + 'access-control/clients/' + orgId, httpOptions);
  }
  getClient(clientId: any, orgId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/clients-apps/' + clientId + '/' + orgId, httpOptions);
  }
  updateClient(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.post(this.serverUrl + 'access-control/update-client', model, httpOptions);
  }
  updateClient_sms_functionality(data: any, clientId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.post(`${this.serverUrl}access-control/update-client-sms-setting/${clientId}`, data, httpOptions);
  }
  deleteClient(clientId: any, orgId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.delete(this.serverUrl + 'access-control/delete-client/' + clientId + '/' + orgId, httpOptions);
  }
  organizationDashboardItems(orgId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + `access-control/org-dashboard/${orgId}`, httpOptions);
  }
  getUnassignedUsers(id: any, clientId?: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + `access-control/users-not-assigned-to-app/${id}/${clientId}`, httpOptions);
  }
  getApplicationAuthSettings(clientId: string, appId: string) {
    return this.httpClient.get(this.serverUrl + `access-control/application-auth-settings/${clientId}/${appId}`);
  }
  setApplicationAuthSettings(clientId: string, appId: string, authSettings: AuthConfig) {
    return this.httpClient.post(this.serverUrl + `access-control/application-auth-settings/${clientId}/${appId}`, authSettings);
  }
  getOrganizationApplicationSetting(appId: string, orgId: string) {
    return this.httpClient.get(this.serverUrl + `access-control/organization-application-details/${appId}/${orgId}`);
  }
  getapplicationbyId(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + `access-control/application-byid/${id}`, httpOptions);
  }
  getAssignedApplications(clientId) {
    return this.httpClient.get(this.serverUrl + `access-control/assigned-client-applications/${clientId}`);
  }
  getClientAppsWithMinDetails(clientId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + 'access-control/clients-apps/' + clientId, httpOptions);
  }
  getClientAppsWithRoles(clientId: any) {
    return this.httpClient.get(this.serverUrl + 'access-control/clients-apps-with-roles/' + clientId);
  }
  getApplicationClients(appId, orgId) {
    return this.httpClient.get(this.serverUrl + 'access-control/application-clients/' + appId + '/' + orgId);
  }
  getApplicationRoles(appId, clientId, module, section, action) {
    return this.httpClient.get(this.serverUrl + `access-control/roles-withno-action/${appId}/${clientId}/${module}/${section}/${action}`);
  }
  assignActionToRoles(details) {
    return this.httpClient.post(this.serverUrl + 'access-control/assign-action-to-roles', details);
  }
  addModuleLicense(model: {
    clientId: string, application_id: string;
    selectedModules: string[]; excludedModules: string[]; visibleModules: string[]; visibleExcluded: string[]; disabledExcluded: string[]; disabledModules: string[];
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.post(this.serverUrl + 'access-control/modules/license', model, httpOptions);
  }
  getSMS_usage(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      })
    };
    return this.httpClient.get(this.serverUrl + `access-control/smsLogs/${data.clientId}?fromDate=${data.fromDate}&toDate${data.toDate}`);
  }

  enableEmailVerification(user_id:String,isEmailVerificationEnabled:Boolean){
    return this.httpClient.put(`${this.serverUrl}access-control/email-verification/${user_id}`,{isEmailVerificationEnabled})
  }


  saveLink(hyperLinks: any, appId: string,clientId: string,) {
    return this.httpClient.put(this.serverUrl + `access-control/application-hyper-links/${clientId}/${appId}`, hyperLinks);
  }
  getLinks( appId: string,clientId: string,) {
    return this.httpClient.get(this.serverUrl + `access-control/get-application-hyper-links/${clientId}/${appId}`);
  }

  emailVerificationStatus(user_id){
    return this.httpClient.get(`${this.serverUrl}access-control/email-verification-status/${user_id}`)
  }
  getMultipleLocationstatus(data: {
    applicationId: String, clientId: String
  }) {
    const { clientId, applicationId } = data;
    return this.httpClient.get(`${this.serverUrl}access-control/client/multiple-locations-status/${clientId}/${applicationId}`)
  }
  getMultipleLocations(data: {
    applicationId: String, clientId: String
  }) {
    const { clientId, applicationId } = data;
    return this.httpClient.get(`${this.serverUrl}access-control/client/multiple-locations/${clientId}/${applicationId}`)
  }
  saveLocations(ids: { clientId: string, userId: string, applicationId: string }, locationList: unknown[]) {
    const { clientId, userId, applicationId } = ids;
    return this.httpClient.post(`${this.serverUrl}access-control/client/multiple-locations/${clientId}/${applicationId}/${userId}`, { locationList })
  }
  removeLocation
    (ids: { applicationId: any; userId: string; clientId: string }, location: string) {
    const { applicationId, userId, clientId } = ids
    return this.httpClient.put(`${this.serverUrl}access-control/client/multiple-locations/${clientId}/${applicationId}/${userId}`, { location })
  }
  getUserLogs(clientId,appId:String=null,roleId:String=null,roleName=null, activity,pageIndex,pageSize,status,startDate,endDate,userName,viewLatest) {
    return this.httpClient.get(this.serverUrl + `access-control/login-reports/${clientId}/${appId}/${roleId}?pageIndex=${pageIndex}&pageSize=${pageSize}&status=${status}&startDate=${startDate}&endDate=${endDate}&userName=${userName}&viewLatest=${viewLatest}&activity=${activity}&roleName=${roleName}`);
  }
  addUserApplicationAccess(data:{isSet:boolean,URL:string},ids:{appId:string,clientId:string}) {
    const {appId,clientId} = ids;
    return this.httpClient.put(`${this.serverUrl}access-control/user-application-access/${clientId}/${appId}`,data)
  }
  getUserApplicationAccess(ids:{appId:string,clientId:string}) {
    const {appId,clientId} = ids;
    return this.httpClient.get(`${this.serverUrl}access-control/user-application-access/${clientId}/${appId}`)
  }
}



